module.exports = __webpack_public_path__ + "img/maker_noa.e2dcc4ca.png";